export function normalizeTechnicalArtifacts(value: string) {
  return value
    .replace(/\u0000/g, "")
    .replace(/\r\n/g, "\n")
    .replace(/_x000D_/gi, " ")
    .replace(/&#x0*D;/gi, " ")
    .replace(/\s{2,}/g, " ")
    .trim();
}

function decodeBasicHtmlEntities(value: string) {
  return value
    .replace(/&nbsp;/gi, " ")
    .replace(/&amp;/gi, "&")
    .replace(/&quot;/gi, '"')
    .replace(/&apos;/gi, "'")
    .replace(/&#39;/g, "'")
    .replace(/&lt;/gi, "<")
    .replace(/&gt;/gi, ">")
    .replace(/&#x([0-9a-f]+);/gi, (_match, hex) => String.fromCodePoint(Number.parseInt(hex, 16)))
    .replace(/&#(\d+);/g, (_match, code) => String.fromCodePoint(Number.parseInt(code, 10)));
}

export function cleanPublicText(value: string | null | undefined) {
  const normalized = normalizeTechnicalArtifacts(decodeBasicHtmlEntities(String(value ?? "")));

  return normalized
    .replace(/<script[\s\S]*?<\/script>/gi, " ")
    .replace(/<style[\s\S]*?<\/style>/gi, " ")
    .replace(/<(br|\/p|\/div|\/li|\/ul|\/ol|\/h[1-6])\b[^>]*>/gi, "\n")
    .replace(/<[^>]+>/g, " ")
    .replace(/\b(?:box-sizing|font-family|font-size|font-weight|font-style|font-variant|font-stretch|line-height|margin|padding|border|vertical-align|color|touch-action|font-optical-sizing|font-kerning|font-feature-settings|font-variation-settings)\s*:[^;\n]+;?/gi, " ")
    .replace(/(?:style|class|href|rel)="[^"]*"/gi, " ")
    .replace(/[<>]+/g, " ")
    .split(/\n+/)
    .map((line) => line.replace(/\s+/g, " ").trim())
    .filter((line) => line && !/^[\s"'=;:./\\-]+$/.test(line))
    .join("\n")
    .trim();
}

export function fixMaybeBrokenText<T>(value: T): T {
  if (typeof value === "string") {
    return normalizeTechnicalArtifacts(value) as T;
  }

  if (Array.isArray(value)) {
    return value.map((item) => fixMaybeBrokenText(item)) as T;
  }

  if (value && typeof value === "object") {
    return Object.fromEntries(
      Object.entries(value).map(([key, item]) => [key, fixMaybeBrokenText(item)])
    ) as T;
  }

  return value;
}
